import React from 'react';
import { string } from 'prop-types';

const AccountIcon = ({
  color = 'sixth-color',
  fontSize = 'var(--base-medium)',
  className = ''
}) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_account ${className}`}
  />
);

AccountIcon.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default AccountIcon;
